import {
  SEARCH_LIST,
  SEARCH_LIST_SUCCESS,
  SEARCH_LIST_ERROR,
  SEARCH_DOWNLOAD,
} from "./actionTypes"


export const searchList = data => ({
  type: SEARCH_LIST,
  payload: data
});

export const searchListSuccess = data => ({
  type: SEARCH_LIST_SUCCESS,
  payload: {data}
});

export const searchListError = error => ({
  type: SEARCH_LIST_ERROR,
  payload: error,
});

export const searchDownload = data => ({
  type: SEARCH_DOWNLOAD,
  payload: data
});
